module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldCondIt.06cc4e3.woff";